import { Editor } from 'grapesjs';
import { RewardsWonTableRenderer } from '@loyalty/editor-components';
import { facRewardHistory } from '@qualifio/ui-commons';
import { EditorComponentDefinition } from '../types';
import { EditorContext } from '../../../services/editor-service';
import {
  RewardsWonTableWidgetTraits,
  rewardsWonTableWidgetTraits,
} from './RewardsWonTableWidgetTraits';
import { Toolbar, buildParticipantContextFromGrape } from '../../utils';

const CLASSNAME = 'qlfeditor-rewards-won__table';

export const rewardsWonTableComponentDefinition: EditorComponentDefinition = {
  id: 'rewards-won-table',
  icon: facRewardHistory,
  getLabel: ({ t }) => t('editor.component.rewards-won'),
  component: RewardsWonTableGrapesComponent,
  traits: {
    schema: rewardsWonTableWidgetTraits,
    form: RewardsWonTableWidgetTraits,
  },
  copyPasteHelper: element => {
    delete element.attributes.currencyIds;
  },
};

export function RewardsWonTableGrapesComponent(editor: Editor) {
  const i18n = editor.I18n;
  const context: EditorContext = editor.Config.context;
  const currencies = context.currencies;

  editor.DomComponents.addType(rewardsWonTableComponentDefinition.id, {
    isComponent(el: HTMLElement) {
      return el.tagName === 'DIV' && el.classList.contains(CLASSNAME);
    },
    model: {
      defaults: {
        tagName: 'div',
        attributes: {
          scrollable: true,
          currencyIds: currencies
            .filter(currency => !currency.deletedAt)
            .map(currency => currency.id),
          includeFreeRewards: true,
        },
        name: 'rewards-won-table',
        content: '',
        droppable: false,
        draggable: false,
        removable: false,
        copyable: false,
        traits: [],
      },
      initToolbar: Toolbar,
      init() {
        this.on('change:attributes', () => setTimeout(() => this.view?.onRender()));
      },
      toHTML(): string {
        return RewardsWonTableRenderer(
          {
            state: context.widgetState,
            options: {
              id: this.getId(),
              attributes: this.getAttributes(),
              i18nAttributes: this.attributes.i18nAttributes || {},
            },
            context: buildParticipantContextFromGrape(i18n),
          },
          editor.Canvas.getDocument(),
        );
      },
    },
    view: {
      onRender() {
        const { el, model } = this;
        el.innerHTML = model.toHTML();
      },
    },
  });
}
